// API Configuration
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// App Assets
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_ltg-mobile-web/artifacts/sa91n6yf_1000238439%20%282%29.png";
export const MASTER_WALLET = "0xad71fbab7325E13EF1E0Fa5e264f0F6b3ce2EB53";

// Exchange Rate
export const LTG_RATE = 1000; // 1 USDT = 1000 LTG
